/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation


import guviPython from "./assets/images/python-guvi.jpg";
import internshalaAI from "./assets/images/internshala-ai.jpg";
import ibmAI from "./assets/images/ibm-ai.jpg";


// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Harsh Gulia",
  title: "Hi, I'm Harsh 👋",
  subTitle: emoji(
    "AI Automation & Web Scraping Specialist 🚀 I build bots, extract data from websites, automate repetitive tasks and create smart workflows using Python, Selenium, APIs and AI tools."
  ),
  resumeLink: "",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/harshguliag416",
  linkedin: "https://www.linkedin.com/in/harshguliag416/",
  gmail: "harshguliag416@gmail.com",
  fiverr: "https://www.fiverr.com/harshguliag416",
  display: true
};

// Skills Section

const skillsSection = {
  title: "What I Do",
  subTitle: "Automation & Data Extraction Specialist",

  skills: [
    emoji("⚡ Website scraping using Python & Selenium"),
    emoji("⚡ Automation bots for repetitive tasks"),
    emoji("⚡ Data extraction into Excel / CSV / Database"),
    emoji("⚡ API data collection & integration")
  ],

  softwareSkills: [
    { skillName: "Python", fontAwesomeClassname: "fab fa-python" },
    { skillName: "Selenium", fontAwesomeClassname: "fas fa-robot" },
    { skillName: "JavaScript", fontAwesomeClassname: "fab fa-js" },
    { skillName: "NodeJS", fontAwesomeClassname: "fab fa-node" },
    { skillName: "GitHub", fontAwesomeClassname: "fab fa-github" },
    { skillName: "HTML", fontAwesomeClassname: "fab fa-html5" },
    { skillName: "CSS", fontAwesomeClassname: "fab fa-css3-alt" }
  ],
  display: true
};


// Education Section

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "KCC Institute of Technology & Management",
      subHeader: "B.Tech Computer Science",
      duration: "2024 - Present",
      desc: "Learning software development, automation and programming.",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Freelance Automation Developer",
      company: "Fiverr",
      date: "2025 – Present",
      desc: "Creating web scraping scripts, automation bots and data extraction solutions for clients worldwide."
    }
  ]
};


// Some big projects you have worked on

const bigProjects = {
  title: "My Work",
  subtitle: "Automation & Scraping Projects",

  projects: [
    {
      projectName: "E-commerce Product Scraper",
      projectDesc: "Scrapes product name, price, rating and images into Excel automatically.",
      footerLink: [{ name: "GitHub", url: "https://github.com/harshguliag416" }]
    },
    {
      projectName: "Form Filling Bot",
      projectDesc: "Automates website form submission using Selenium.",
      footerLink: [{ name: "Fiverr", url: "https://www.fiverr.com/harshguliag416" }]
    },
    {
      projectName: "Bulk Data Extractor",
      projectDesc: "Collects thousands of records from websites into CSV database.",
      footerLink: [{ name: "LinkedIn", url: "https://www.linkedin.com/in/harshguliag416/" }]
    }
  ],
  display: true
};


// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Need a scraper, bot or automation? Message me anytime.",
  number: "9873072357",
  email_address: "harshguliag416@gmail.com"
};

const twitterDetails = {
  userName: "",
  display: false
};

const achievementSection = {
  title: emoji("Certificates & Achievements 🏆"),
  subtitle: "My verified certifications in AI, Python and Automation",

  achievementsCards: [
    {
      title: "Python Programming Certification",
      subtitle: "Completed Python course from GUVI (HCL Partner)",
      image: guviPython,
      imageAlt: "GUVI Python Certificate",
      footerLink: [
        { name: "View Certificate", url: guviPython }
      ]
    },

    {
      title: "Agentic AI Internship Selection",
      subtitle: "Selected for AI Internship at Multiverz via Internshala",
      image: internshalaAI,
      imageAlt: "Internshala AI Certificate",
      footerLink: [
        { name: "View Certificate", url: internshalaAI }
      ]
    },

    {
      title: "IBM Artificial Intelligence Internship",
      subtitle: "Virtual Internship — IBM Developer Skills Network",
      image: ibmAI,
      imageAlt: "IBM AI Certificate",
      footerLink: [
        {
          name: "Verify Certificate",
          url: "https://courses.ibmmooc.skillsnetwork.site/certificates/4283a6ea50294dcb80813ca654da11d4"
        }
      ]
    }
  ],

  display: true
};

const talkSection = {
  display: false
};

const podcastSection = {
  display: false
};

const openSource = {
  showGithubProfile: "true",
  display: true
};
const blogSection = {
  display: false
};

const isHireable = true;
export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
